module.exports = __webpack_public_path__ + "img/Math_8.55bcd531.svg";